<template lang="pug">
  div.mt-2
    template(
      v-if="loaded")
      .list-mobile
        planning-item-mobile(
          v-for="item in schedules"
          :key="item.id"
          :item="item"
          @on-update-coefficient="updateData"
          @update="loadData")

        v-table-body(
          v-if="loaded"
          outsideTable)
        
        list-empty(v-if="!schedules.length")

    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton.list-mobile__title-skeleton--type-2
          .list-mobile__content.mt-1
            .list-mobile__item(v-for="j in 2" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-2
            .list-mobile__item(v-for="k in 2" :key="`${i}-${k}-${i}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-2
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-2
            .list-mobile__item.mt-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-2
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-2
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import PlanningItemMobile from './PlanningItemMobile'
import ListEmpty from './ListEmpty'

export default {
  name: 'PlanningListMobile',

  components: {
    PlanningItemMobile,
    ListEmpty
  },

  data: () => ({
    loaded: false
  }),

  computed: {
    ...mapGetters('schedule', [
      'schedules'
    ]),

    date () {
      return this.$route.params.loading_date
    },

    loading () {
      return this.$route.params.loading_id
    },
    planned_on () {
      return this.$route.params.planned_on
    },
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('schedule', [
      'loadSchedules',
      'sortSchedules'
    ]),

    async loadData () {
      const params = {
        farm: this.$route.params.farm_id,
        loading: this.$route.query.loading || this.loading,
        planned_on: this.$route.query.date || this.planned_on
      }

      if (params.loading && params.planned_on) {
        await this.loadSchedules(params)
      }
      this.loaded = true
    },
    async updateData (item) {
      await this.updateSchedule(item.id, item)
    },
    async updateSchedule (id, item) {
      if (!item.deleted && item.schedule_groups.length &&
        !item.schedule_mixer.deleted && !item.schedule_ration.deleted) {
        await api.schedule.updateById(id, item)
      }
    }
  },

  watch: {
    date () {
      this.loaded = false
      this.loadData()
    },

    loading () {
      if (this.loaded) {
        this.loaded = false
        this.loadData()
      }
    },

    '$route.params': {
      handler () {
        this.loaded = false
        this.loadData()
      },
      immediate: true
    },

    '$route.query': {
      handler () {
        this.loaded = false
        this.loadData()
      },
      immediate: true
    }
  }
}
</script>
